import React from 'react'
import { Button as AntButton, ButtonProps, Spin } from 'antd'
import style from './Button.module.css'
import classNames from 'classnames'
import { LoadingOutlined } from '@ant-design/icons'

interface CustomButtonProps extends ButtonProps {
  text?: string
  type?: 'primary' | 'cancel' | 'actions' | 'green' | 'orange' | 'danger'
  isLoading?: boolean
}

export const Button: React.FC<CustomButtonProps> = ({
  text,
  type = 'primary',
  isLoading,
  ...props
}) => {
  return (
    <AntButton
      className={classNames(style.customButton, style[type])}
      {...props}
    >
      {isLoading && <Spin indicator={<LoadingOutlined spin />} size='small' />}
      <span className={style.customButtonText}>{text}</span>
    </AntButton>
  )
}
